import { useSyncExternalStore } from 'react';

const listeners = new Set<() => void>();
let installed = false;
const notify = () => listeners.forEach(listener => listener());

function subscribe(listener: () => void) {
  if (!installed) {
    installed = true;
    // Existing pages call history directly. Observe those calls rather than
    // maintaining a second, stale URL state or forcing a document reload.
    for (const method of ['pushState', 'replaceState'] as const) {
      const original = window.history[method].bind(window.history);
      window.history[method] = (...args: Parameters<History[typeof method]>) => {
        original(args[0], args[1], args[2]);
        notify();
      };
    }
    window.addEventListener('popstate', notify);
    window.addEventListener('hashchange', notify);
  }
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function navigateUrl(url: string, replace = false) {
  window.history[replace ? 'replaceState' : 'pushState'](null, '', url);
}

export function useBrowserLocation() {
  const href = useSyncExternalStore(subscribe, () => window.location.href, () => 'http://localhost/');
  return new URL(href);
}